import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function ModulesSection() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('risk');

  const modules = [
    {
      id: 'risk',
      name: t('modules.risk'),
      icon: 'ri-shield-check-line',
      title: t('risk.title'),
      features: [
        t('risk.feature1'),
        t('risk.feature2'),
        t('risk.feature3'),
        t('risk.feature4')
      ]
    },
    {
      id: 'planning',
      name: t('modules.planning'),
      icon: 'ri-calendar-check-line',
      title: t('planning.title'),
      features: [
        t('planning.feature1'),
        t('planning.feature2'),
        t('planning.feature3'),
        t('planning.feature4'),
        t('planning.feature5')
      ]
    },
    {
      id: 'execution',
      name: t('modules.execution'),
      icon: 'ri-play-circle-line',
      title: t('execution.title'),
      features: [
        t('execution.feature1'),
        t('execution.feature2'),
        t('execution.feature3'),
        t('execution.feature4'),
        t('execution.feature5'),
        t('execution.feature6')
      ]
    },
    {
      id: 'communication',
      name: t('modules.communication'),
      icon: 'ri-message-3-line',
      title: t('communication.title'),
      features: [
        t('communication.feature1'),
        t('communication.feature2'),
        t('communication.feature3'),
        t('communication.feature4'),
        t('communication.feature5')
      ]
    }
  ];

  const activeModule = modules.find(module => module.id === activeTab) || modules[0];

  return (
    <section id="features" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t('modules.title')}
          </h2>
        </div>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="flex flex-wrap border-b border-gray-200">
            {modules.map((module) => (
              <button
                key={module.id}
                onClick={() => setActiveTab(module.id)}
                className={`flex-1 min-w-0 px-6 py-4 text-center font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  activeTab === module.id
                    ? 'bg-blue-600 text-white border-b-2 border-blue-600'
                    : 'text-gray-600 hover:text-blue-600 hover:bg-gray-50'
                }`}
              >
                <i className={`${module.icon} text-xl mr-2`}></i>
                {module.name}
              </button>
            ))}
          </div>

          <div className="p-8 lg:p-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">
                  {activeModule.title}
                </h3>
                <ul className="space-y-4">
                  {activeModule.features.map((feature, index) => (
                    <li key={index} className="flex items-start">
                      <i className="ri-check-line text-blue-600 text-xl mr-3 mt-1 flex-shrink-0"></i>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="relative">
                <img
                  src={`https://readdy.ai/api/search-image?query=Modern%20digital%20audit%20platform%20interface%20showing%20$%7BactiveModule.name.toLowerCase%28%29%7D%20management%20dashboard%20with%20charts%20graphs%20and%20data%20visualization%2C%20professional%20business%20software%20design%2C%20clean%20user%20interface%20with%20blue%20and%20white%20color%20scheme%2C%20technology%20and%20innovation%20theme&width=600&height=400&seq=${activeModule.id}-img&orientation=landscape`}
                  alt={activeModule.name}
                  className="w-full h-80 object-cover rounded-xl shadow-lg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}